import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Banking = () => {
  const [accounts, setAccounts] = useState([]);
  const [journals, setJournals] = useState([]);
  const [ledger, setLedger] = useState([]);
  const [accountForm, setAccountForm] = useState({
    accountNumber: '',
    bankName: '',
    balance: 0,
  });
  const [journalForm, setJournalForm] = useState({
    date: '',
    description: '',
    debitAccount: '',
    creditAccount: '',
    amount: 0,
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [accountsRes, journalsRes, ledgerRes] = await Promise.all([
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/banking/accounts`),
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/banking/journals`),
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/banking/ledger`),
      ]);
      setAccounts(accountsRes.data);
      setJournals(journalsRes.data);
      setLedger(ledgerRes.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleAccountSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${window.location.protocol}//${window.location.hostname}/api/banking/accounts`, accountForm);
      setAccountForm({
        accountNumber: '',
        bankName: '',
        balance: 0,
      });
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  const handleJournalSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${window.location.protocol}//${window.location.hostname}/api/banking/journals`, journalForm);
      setJournalForm({
        date: '',
        description: '',
        debitAccount: '',
        creditAccount: '',
        amount: 0,
      });
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <h2>Banking</h2>
      <h3>Add Bank Account</h3>
      <form onSubmit={handleAccountSubmit}>
        <input name="accountNumber" placeholder="Account Number" value={accountForm.accountNumber} onChange={(e) => setAccountForm({ ...accountForm, accountNumber: e.target.value })} required />
        <input name="bankName" placeholder="Bank Name" value={accountForm.bankName} onChange={(e) => setAccountForm({ ...accountForm, bankName: e.target.value })} required />
        <input name="balance" type="number" placeholder="Balance" value={accountForm.balance} onChange={(e) => setAccountForm({ ...accountForm, balance: parseFloat(e.target.value) })} required />
        <button type="submit">Add Account</button>
      </form>
      <h3>Record Journal Entry</h3>
      <form onSubmit={handleJournalSubmit}>
        <input name="date" type="date" value={journalForm.date} onChange={(e) => setJournalForm({ ...journalForm, date: e.target.value })} required />
        <input name="description" placeholder="Description" value={journalForm.description} onChange={(e) => setJournalForm({ ...journalForm, description: e.target.value })} required />
        <input name="debitAccount" placeholder="Debit Account" value={journalForm.debitAccount} onChange={(e) => setJournalForm({ ...journalForm, debitAccount: e.target.value })} />
        <input name="creditAccount" placeholder="Credit Account" value={journalForm.creditAccount} onChange={(e) => setJournalForm({ ...journalForm, creditAccount: e.target.value })} />
        <input name="amount" type="number" placeholder="Amount" value={journalForm.amount} onChange={(e) => setJournalForm({ ...journalForm, amount: parseFloat(e.target.value) })} required />
        <button type="submit">Record Entry</button>
      </form>
      <h3>Bank Accounts</h3>
      <ul>
        {accounts.map(account => (
          <li key={account.id}>{account.accountNumber} - {account.bankName} - Balance: ${account.balance}</li>
        ))}
      </ul>
      <h3>Journal Entries</h3>
      <ul>
        {journals.map(entry => (
          <li key={entry.id}>{entry.date} - {entry.description} - ${entry.amount}</li>
        ))}
      </ul>
      <h3>Ledger</h3>
      <ul>
        {ledger.map(entry => (
          <li key={entry.id}>{entry.accountName} ({entry.accountType}) - Balance: ${entry.balance}</li>
        ))}
      </ul>
    </div>
  );
};

export default Banking;